import React, { Component } from "react";
import Panel from "../../../components";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  HelpBlock,
  Alert
} from "react-bootstrap";
import { createBrowserHistory } from "history";

import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import loader from "../../../style/loader/loader.scss";
import { withRouter, Link } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import isEmpty from "lodash.isempty";
import idx from 'idx';
import { subAdminActions, get_user_details } from "../../../redux/actions/subAdminActions";
import ACL_LIST from "./aclList";
import {
  renderAlert,
  clearAlert,
  alertsActions
} from "../../../redux/actions/alertsActions";
import './aclStyle.css';

const history = createBrowserHistory();

class AclSettings extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    const viewLink = (props.match && props.match.params) && `acl/settings/${props.match.params.userId}`
    this.state = {
      path: ["Home", "Manage Employee", "ACL"],
      links:["home", "userList", viewLink],
      acl_settings: [],
      permissionList: [],
      alertMessage: "",
      show: false,
      msgType: "",
      loading: false,
      message: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange = event => {
    let checkValue = event.target.value;
    let checkIndex = this.state.acl_settings.indexOf(checkValue);
    let tmpAclSetting = this.state.acl_settings;
    if (checkIndex >= 0) {
      tmpAclSetting.splice(checkIndex, 1);
    } else {
      tmpAclSetting.push(checkValue);
    }
    this.setState({ acl_settings: tmpAclSetting });
  };

  componentDidMount() {
    if (idx(this.props, _ => _.match.params.userId)) {
      this.setState({ userId: this.props.match.params.userId });
      this.props.get_user_details(this.props.match.params.userId);
      const {
        actions: { get_permission_list }
      } = this.props;
      get_permission_list(this.props.match.params.userId);
      
    }
  }

  componentWillReceiveProps(nextProps) {
    if (idx(nextProps, _ => _.permissionList.action_permission) && nextProps.permissionList.action_permission != this.state.permissionList) {
      this.setState({
        permissionList: nextProps.permissionList.action_permission,
        loading: false
      });
    }
    if (idx(nextProps, _ => _.permissionList.acl_permission) && nextProps.permissionList.acl_permission != this.state.acl_settings) {
      this.setState({
        acl_settings: nextProps.permissionList.acl_permission,
        loading: false
      });
    }
    if (idx(nextProps, _ => _.aclSetting.data)  && nextProps.aclSetting.data != this.state.acl_settings) {
      this.setState({
        acl_settings: nextProps.aclSetting.data,
        loading: false
      });
    }
    if (idx(nextProps, _ => _.aclSetting.response) && nextProps.aclSetting.response != this.state.message) {
      this.setState({
        msgType: nextProps.aclSetting.response,
        message: nextProps.aclSetting.message,
        loading: false
      });
    }
    if (nextProps.error) {
      this.setState({
        msgType: "error",
        message: nextProps.error,
        loading: false
      });
    }

    setTimeout(
      function() {
        this.setState({
          msgType: "",
          message: ""
        });
      }.bind(this),
      5000
    );
  }

  handleFormSubmit = event => {
    event.preventDefault();
    
    let formData = {
      userID : this.state.userId,
      acl_settings: this.state.acl_settings.join()
    }
    const {
      actions: { savePermission }
    } = this.props;
    savePermission(formData);
    this.setState({
      loading: true
    });
  };

  checkAclSetting(aKey){
    return (this.state.acl_settings.indexOf(aKey) >= 0); // || aKey.indexOf('LIST_') >= 0
  }

  checkReadOnly(aKey){
    return false;
  }

  renderAlert() {
    if (this.state.msgType && this.state.message) {
      let msgClass =
        this.state.msgType == "error"
          ? "alert alert-danger"
          : "alert alert-" + this.state.msgType;
      return (
        <div className={msgClass}>
          <strong>{this.state.msgType.toUpperCase()} :</strong>{" "}
          {this.state.message}
        </div>
      );
    }
  }

  render() {
    let aclGroup;
    const {permissionList} = this.state;
    aclGroup = permissionList.map((agval, agindex) => (
      <div key={'panel'+agindex} className="panel panel-default">
        <div className="panel-heading" role="tab" id="headingOne">
          <h4 className="panel-title">
          <a role="button" data-toggle="collapse" data-parent="#accordion" href={'#collapse'+agindex} aria-expanded="true" aria-controls={'collapse'+agindex}>
            {agval.aLabel}
          </a>
        </h4>
        </div>
        <div id={'collapse'+agindex} className="panel-collapse collapse in" role="tabpanel" aria-labelledby={'heading'+agindex}>
          <div className="panel-body">
            {agval.aList.map((fval, findex) => (
                <Row key={'prow'+findex} className="aclRow">
                  <Col md={4} xs={12}><strong>{fval.aKey}</strong></Col>
                  <Col md={6} xs={12}>{fval.aDesc}</Col>
                  <Col md={2} xs={12}><Checkbox
                  inline
                  name="acl_settings"
                  onChange={this.handleInputChange}
                  key={fval.aKey+''+findex}
                  value={fval.aKey}
                  disabled={this.checkReadOnly(fval.aKey)}
                  defaultChecked={this.checkAclSetting(fval.aKey)}
                  >
                </Checkbox></Col>
                </Row>
              ))}
          </div>
        </div>
      </div>));

    return (
      <div className="col-lg-12 add-sub-admin">
        {this.state.loading === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {this.renderAlert()}
        <form>
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context} />
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading">ACL Managements</header>

            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}

            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={12} xs={12}>
                    <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                      {aclGroup}
                    </div>
                  </Col>

                </Row>
              </div>
            </div>
          </div>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="button"
                onClick={this.handleFormSubmit}
                id="saveButton"
                disabled={this.props.loading}
              >
                Save
              </Button>
              <Button
                bsStyle="default"
                onClick={() => this.context.router.history.push(`/userList`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.subAdminReducer.error,
    userDetails: state.subAdminReducer.userDetails,
    permissionList: state.subAdminReducer.permissionList,
    aclSetting: state.subAdminReducer.aclSetting, 
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    loading: state.subAdminReducer.sending
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get_user_details,
    actions: bindActionCreators(
      {
        ...subAdminActions,
        ...alertsActions
      },
      dispatch
    )
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(AclSettings);



// WEBPACK FOOTER //
// ./src/app/views/admin/subAdmin/AclSettings.js